// 当前运营控制台源码维护说明，更新时间：2026-09-01 01:01 CST。后续修改本文件功能时，请同步更新注释、版本号和更新时间。
/* HotX 免费证书路由备份注释
 * 注释时间：2026-08-29 20:42 CST
 * /https 当前固定指向 src/views/HttpsView.vue，这里是证书管理已跑通版本的路由入口。
 * 不要随意切回 FreeCertificatePage.vue，除非完整迁移重签置顶、操作时间、失败中文化和快照释放逻辑。
 */

import type { RouteRecordRaw } from 'vue-router';

/*
 * 注释时间：2026-08-29 20:42 CST
 * Page Capsule: HTTPS certificate management route.
 * 当前 /https 已跑通并固定指向 src/views/HttpsView.vue：该页面包含重签立即置顶、刷新后保持置顶、点击后即时签发中反馈。
 * 不要改回 FreeCertificatePage.vue，除非同步迁移完整的重签置顶/行保留/localStorage 快照逻辑。
 * 边界：本路由只承载证书申请、DNS 验证、证书状态、下载和自动续期，不承载域名管理提交流。
 */
export const freeCertificateRoute: RouteRecordRaw = {
  path: '/https',
  name: 'https',
  component: () => import('../../views/HttpsView.vue'),
  meta: { requiresAuth: true, breadcrumb: ['证书管理'], dirtyCheck: true }
};
